
  (() => {
    const initMobileDots = () => {
      document.querySelectorAll('media-gallery').forEach((gallery) => {
        if (gallery.dataset.mobileDotsReady === 'true') return;
        gallery.dataset.mobileDotsReady = 'true';

        const dots = gallery.querySelectorAll('.ss-mobile-dot');
        const slideshow = gallery.querySelector('slideshow-component, slideshow-container, slideshow-carousel, .slideshow');
        const slides = gallery.querySelectorAll('slideshow-slide, .slideshow-slide');

        if (!dots.length || !slides.length) return;

        const setActiveDot = (index) => {
          dots.forEach((dot, dotIndex) => {
            dot.classList.toggle('is-active', dotIndex === index);
          });
        };

        dots.forEach((dot) => {
          dot.addEventListener('click', () => {
            const index = Number(dot.dataset.slideIndex);
            const targetSlide = slides[index];

            if (targetSlide) {
              targetSlide.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'center'
              });
            }

            setActiveDot(index);
          });
        });

        const observer = new IntersectionObserver(
          (entries) => {
            let mostVisibleSlide = null;
            let highestRatio = 0;

            entries.forEach((entry) => {
              if (entry.intersectionRatio > highestRatio) {
                highestRatio = entry.intersectionRatio;
                mostVisibleSlide = entry.target;
              }
            });

            if (!mostVisibleSlide) return;

            const index = Array.from(slides).indexOf(mostVisibleSlide);

            if (index >= 0) {
              setActiveDot(index);
            }
          },
          {
            root: slideshow || gallery,
            threshold: [0.4, 0.6, 0.8]
          }
        );

        slides.forEach((slide) => observer.observe(slide));
      });
    };

    document.addEventListener('DOMContentLoaded', initMobileDots);
    document.addEventListener('shopify:section:load', initMobileDots);
  })();
